// depends-on: Bootstrap mobile
// depends-on: efw.local
/* global require */
(function ($) {
    const ID = require('./efw.id');

    // Eightfold Way grow-box plugin for inline-expanding content sections
    $.fn.efw$helpAccordion = function (/* options */) {

        return this.each(function () {
            let $this = $(this);

            // do nothing if we're in edit-mode.
            if ($this.closest('.edit-mode').length > 0)
                return;

            // expect a sequence of <h3> followed by <div>
            $this.find('h3').each(function () {
                let $header = $(this),
                    $body = $header.next('div'),
                    $item = $(this).add($body), // both.
                    id = ID(),
                    $headerLink = $('<a class="grow-link item-controller collapsed" href="#' + id + '" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="' + id + '"></a>');

                // collapse markup.
                $item.wrapAll($('<div class="item-wrapper"></div>'));
                $header.wrapInner($headerLink);
                $header.find('a').append($('<span class="item-control mini item-control-grow"><img src="/master_images/3/small_plus.svg" alt="Open"></span>'));
                $header.find('a').append($('<span class="item-control mini item-control-shrink"><img src="/master_images/3/small_minus.svg" alt="Close"></span>'));
                $body.attr('id', id);
                $body.attr('data-parent', '.helpAccordion');
                $body.addClass('collapse');
                $body.wrapInner($('<div class="item-content"></div>'));

                // if marked to be open, open.
                if ($header.hasClass('show')) {
                    //console.info('...showing panel');
                    $body.addClass('show');
                    $header.find('a').removeClass('collapsed').attr('aria-expanded', 'true');
                }
            });
        });
    }

    $.fn.efw$helpPanel = function (/* options */) {
        // plop a membrane behind the whole help situation
        $(document).on('show.bs.collapse', '.popover-panel', function (e) {
            if ($(e.target).is('.popover-panel')) {
                let $membrane = $('<div class="membrane"></div>');
                $('body').append($membrane);
                $membrane.on('click', function () { $('.popover-panel').collapse('hide') });
            }
        });
        $(document).on('hide.bs.collapse', '.popover-panel', function (e) {
            if ($(e.target).is('.popover-panel')) {
                $('body').find('.membrane').addClass('fading');
            }
        });
        $(document).on('hidden.bs.collapse', '.popover-panel', function (e) {
            if ($(e.target).is('.popover-panel')) {
                $('body').find('.membrane').remove();
            }
        });
        // hide the help panel when any dialog comes up.
        $(document).on('show.bs.modal', function () {
            $('.popover-panel').collapse('hide');
        });
    };

    // activate globally.
    $(document).ready(function () {
        // Make accordion1 a proxy for helpAccordion
        $('div.accordion1').addClass('helpAccordion');
        $('div.helpAccordion').efw$helpAccordion();
        $('div.helpPanel').efw$helpPanel();
    });
})(jQuery);
